"use client"

import FullPageModal from "@/app/components/FullPageModal"
import useBaseBlogUrl from "@/app/hooks/useBaseBlogUrl"
import { useRouter } from "next/navigation"

/**
 * Client wrapper for the Subscribe layout.
 *
 * We render this in a full-page modal so the user can X out of it
 * if they happen to refresh.
 */
export default function ClientLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const baseBlogUrl = useBaseBlogUrl()
  const router = useRouter()

  return (
    <FullPageModal
      onDismiss={() => {
        router.push(baseBlogUrl)
      }}
    >
      {children}
    </FullPageModal>
  )
}
